import React from 'react';
import PropTypes from 'prop-types';

import accounting from 'accounting';
import fecha from 'fecha';
import format from '../../../../utils/format';

import '.././PropertyDetailBasicInfo.css';
import { DATE_FORMAT, PROPERTY_TYPES } from '../../../../constants';

const items = {
  address: {
    label: 'Address',
    value: ({ basicInfo: { location = {} } = {} }) => location.street,
  },
  suite: {
    label: 'Suite',
    value: ({ basicInfo: { location = {} } = {} }) => location.suite,
  },
  unit: {
    label: 'Unit',
    value: ({ basicInfo: { location = {} } = {} }) => location.unit,
  },
  city: {
    label: 'City',
    value: ({ basicInfo: { location = {} } = {} }) => location.city,
  },
  state: {
    label: 'State',
    value: ({ basicInfo: { location = {} } = {} }) => location.state,
  },
  county: {
    label: 'County',
    value: ({ basicInfo: { location = {} } = {} }) => location.countyName,
    condition: ({ basicInfo }) => basicInfo.location.country === 'US',
  },
  buildingType: {
    label: 'Building Type',
    value: ({ additionalDetails: { about = {} } = {} }) => (about.buildingType || []).join(', '),
    condition: ({ type }) => type === PROPERTY_TYPES.BUILDINGS,
  },
  availableSqft: {
    label: 'Available SF',
    value: ({ basicInfo: { availableSquareFeet = {} } = {} }) => format(availableSquareFeet),
    condition: ({ type }) => type === PROPERTY_TYPES.BUILDINGS,
  },
  sizeSize: {
    label: 'Acres',
    value: ({
      additionalDetails: {
        external: {
          siteSize = null,
        } = {},
      } = {},
    }) => parseFloat(siteSize),
    condition: ({ type }) => type === PROPERTY_TYPES.BUILDINGS,
  },
  acres: {
    label: 'Acres',
    value: ({ basicInfo: { acres = {} } = {} }) => format(acres),
    condition: ({ basicInfo: { acres } = {} }) => acres !== undefined,
  },
  salePrice: {
    label: 'Sale Price',
    value: ({ basicInfo: { pricing = {} } = {} }) => accounting.formatMoney(pricing.salePrice),
    condition: ({ basicInfo: { pricing: { salePrice } = {} } = {} }) => salePrice > 0,
  },
  pricingNote: {
    label: 'Pricing Note',
    value: ({ basicInfo: { pricing = {} } = {} }) => pricing.pricingNote,
  },
  leaseRate: {
    label: 'Lease Rate (SF/Year)',
    value: ({ basicInfo: { pricing = {} } = {} }) => accounting.formatMoney(pricing.leaseRate),
    condition: ({ basicInfo: { pricing: { leaseRate } = {} } = {} }) => leaseRate > 0,
  },
  leaseRateNote: {
    label: 'Lease Rate Note',
    value: ({ basicInfo: { pricing = {} } = {} }) => pricing.leaseRateNote,
  },
  leaseTerms: {
    label: 'Lease Terms',
    value: ({ basicInfo: { pricing = {} } = {} }) => pricing.leaseTerms,
    condition: ({ basicInfo: { pricing: { leaseTerms } = {} } = {} }) => leaseTerms !== 'Unknown',
  },
  lastUpdated: {
    label: 'Last Updated',
    value: ({ dateModified }) => {
      return dateModified && dateModified !== 'Unavailable'
        ? fecha.format(new Date(dateModified), DATE_FORMAT)
        : 'Unavailable';
    },
  },
};

export function PropertyInfo(props) {
  let displayedAcres = false;
  const { displayKeys } = props;
  const list = displayKeys.map(key => {
    const item = items[key];
    const itemLabel = item.label === 'Unit' ? 'Suite' : item.label;
    const value = item.value(props);
    let condition = item.condition ? item.condition(props) : true;
    if (condition && itemLabel === 'Acres' && displayedAcres) {
      condition = false;
    } else if (condition && itemLabel === 'Acres') {
      displayedAcres = true;
    }
    return (!!value && condition && <li key={key}><span>{itemLabel}:</span>{value}</li>);
  });

  return (
    <ul className="property-info">
      { list }
    </ul>
  );
}

PropertyInfo.propTypes = {
  displayKeys: PropTypes.arrayOf(PropTypes.string),
};

export default PropertyInfo;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailBasicInfo/PropertyInfo/PropertyInfo.js